// extracted by mini-css-extract-plugin
export default {"container":"styles_container__-EzQB","label":"styles_label__6KOXX"};